module.exports = __webpack_public_path__ + "img/avatar6.2b9065e0.png";